import { render } from "./HeaderLayout.vue?vue&type=template&id=45b7f9da"
const script = {}

import exportComponent from "/home/runner/work/azure-caf-pnp/azure-caf-pnp/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__